export default "__VITE_ASSET__fUVc5ZXC__"